export default __webpack_public_path__ + "static/media/seiseki1.ea550e08.png";